import React, { useState } from "react";
import { Box, Grid, Typography, Button, Modal, RadioGroup, FormControlLabel, Radio, CircularProgress } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { ProgramAccess } from "../api";

const InactiveAccountDashboard = ({handleGetOrg, org}) => {
  const [open, setOpen] = useState(false);
  const [programType, setProgramType] = useState("");
  const [paymentHandling, setPaymentHandling] = useState("");

  const [pending, setPending] = useState(false);


  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setProgramType("");
    setPaymentHandling("");
  };

  const handleSubmit = async () => {
    setPending(true);
    try{
      let res = await ProgramAccess({ program_type: programType, payment_handling: paymentHandling, org_id: org._id });
      if(res.data.url){
        window.location.href = res.data.url;
      }
      await handleGetOrg();
    }catch(ex){
      let error = ex.response ? ex.response.data.message : ex.message;
      alert(error); 
    }finally{
      setPending(false);
      handleClose();
    }
  };

  return (
    <Box container className="mx-20 mt-10" textAlign="center">
      <Typography variant="h4" gutterBottom>
        Expand Your Reach with Career Roshi
      </Typography>

      <Box mt={4} mb={4}>
        <Typography variant="body1" paragraph>
          Your account is not currently set up to list programs. Whether you want
          to sell your programs or advertise them to generate interest, becoming
          a listed organization on our platform gives you incredible opportunities.
        </Typography>

        <ul style={{ textAlign: "left", display: "inline-block" }}>
          <li>
            Add programs to the shared marketplace, visible to a wide audience.
          </li>
          <li>
            Create a unique marketplace URL for your organization to showcase
            your programs directly to your members or community.
          </li>
          <li>
            Choose how you'd like to manage your programs: for sale or for advertising.
          </li>
        </ul>

        <Typography variant="body1" paragraph>
          Click the button below to request access and fill out a short form. Once
          approved, you’ll be able to start uploading your programs and sharing
          your marketplace!
        </Typography>
      </Box>

      <Button
        variant="contained"
        color="primary"
        size="large"
        style={{ padding: "10px 20px", borderRadius: "8px" }}
        onClick={handleOpen}
      >
        Request Marketplace Access
      </Button>

      <Modal open={open} onClose={handleClose} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box bgcolor="white" p={4} borderRadius={8} width="500px">
          {!programType ? (
            <>
              <Typography variant="h6" gutterBottom>
                What do you want to do with your programs?
              </Typography>
              <RadioGroup value={programType} onChange={(e) => setProgramType(e.target.value)}>
                <FormControlLabel
                  value="sale"
                  control={<Radio color="primary" />}
                  label="Sell Programs"
                />
                <Typography variant="body2" gutterBottom>
                  Sell Programs: List programs for direct purchase, allowing users to pay online. You can choose how payments are handled.
                </Typography>
                <FormControlLabel
                  value="advertising"
                  control={<Radio color="primary" />}
                  label="Advertise Programs"
                />
                <Typography variant="body2">
                  Advertise Programs: Display your programs in the marketplace for visibility. Users can submit contact information, and you’ll receive those leads for follow-up.
                </Typography>
              </RadioGroup>
              <div className="d-flex justify-content-end w-100">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClose}
                  style={{ marginTop: "20px" }}
                  disabled={pending}
                >
                  Cancel
                </Button>
              </div>
            </>
          ) : programType === "sale" && !paymentHandling ? (
            <>
              <Typography variant="h6" gutterBottom>
                How would you like payments to be handled?
              </Typography>
              <RadioGroup value={paymentHandling} onChange={(e) => setPaymentHandling(e.target.value)}>
                <FormControlLabel
                  value="stripe_connect"
                  control={<Radio color="primary" />}
                  label="Stripe Connect (Direct Payments)"
                />
                <Typography variant="body2" gutterBottom>
                  Payments are processed through Stripe Connect and transferred directly to your account after setup. Stripe Connect includes a secure dashboard for managing transactions, tracking payments, and monitoring payouts. Payments are held for a return period (e.g., 21 days) before transfer to cover potential refunds.
                </Typography>
                <FormControlLabel
                  value="centralized_payment"
                  control={<Radio color="primary" />}
                  label="Platform Managed (Centralized Payments)"
                />
                <Typography variant="body2">
                  Payments are collected by our platform and sent to you via check or bank transfer after a return period (e.g., 21 days). No additional accounts are required, and all payment tracking and distributions are managed by the platform.
                </Typography>
              </RadioGroup>
              <div className="d-flex justify-content-end w-100">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClose}
                  style={{ marginTop: "20px" }}
                  disabled={pending}
                >
                  Cancel
                </Button>
              </div>
            </>
          ) : (
            <>
              <Typography variant="h6" gutterBottom>
                Review and Submit
              </Typography>
              <Typography variant="body1" paragraph>
                You have selected the program type:{" "}
                {programType === "sale"
                  ? "Sell Programs (Programs for sale)"
                  : "Advertise Programs (Promotional programs)"}
              </Typography>
              {programType === "sale" && (
                <Typography variant="body1" paragraph>
                  Your chosen payment handling method is:{" "}
                  {paymentHandling === "stripe_connect"
                    ? "Stripe Connect (Direct Payments)"
                    : "Platform Managed (Centralized Payments)"}
                </Typography>
              )}
              <Typography variant="body1" paragraph>
                You’re just one step away! To access the program dashboard, please click the "Submit" button to complete the process.
              </Typography>
              <div className="d-flex justify-content-end w-100">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  style={{ marginTop: "20px" }}
                  disabled={pending}
                >
                  {pending ? (
                    <>
                      <CircularProgress
                        size="20px"
                        style={{ color: "#3783e7" }}
                      />
                    </>
                  ) : (
                    "Submit"
                  )}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClose}
                  style={{ marginTop: "20px", marginLeft: '10px' }}
                  disabled={pending}
                >
                  Cancel
                </Button>
              </div>
            </>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default InactiveAccountDashboard;
